import type React from "react";

/**
 * Loading placeholder for {@link ImpersonateUserRow}, matching its avatar + two-line layout so the
 * swap to real rows doesn't shift the list.
 * @param props.rows - Number of placeholder rows to render.
 * @returns A list of pulsing row placeholders.
 */
export function ImpersonateUserRowSkeleton({ rows = 6 }: { rows?: number }): React.ReactElement {
  return (
    <div aria-hidden="true" className="space-y-2">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="w-full flex items-center gap-3 p-3 rounded-2xl border border-gray-200">
          <div className="w-10 h-10 rounded-full flex-shrink-0 animate-pulse bg-gray-100" />
          <div className="flex-1 min-w-0 space-y-2">
            <div className="h-3.5 w-2/5 animate-pulse rounded bg-gray-100" />
            <div className="h-3 w-3/5 animate-pulse rounded bg-gray-100" />
          </div>
        </div>
      ))}
    </div>
  );
}
